import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UUID } from '@/types';
import { useDatasourceId } from '@/hooks';
import { useAppSelector } from '@/store/hooks';
import { selectLastUpdateMethod } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';

export const useNavigateToNextQuery = (
  nextQueryId: Maybe<UUID>,
  currentQueryIdRef: React.MutableRefObject<Maybe<UUID>>,
) => {
  const datasourceId = useDatasourceId();
  const navigate = useNavigate();
  const lastUpdateMethod = useAppSelector(selectLastUpdateMethod);
  /*
  When steps have been saved we receive new query id => store it ref => navigate(update URL).
  After navigation is complete stored query id === url query id
   */
  React.useEffect(() => {
    if (
      lastUpdateMethod === LAST_UPDATE_METHOD.stepsSidebarInteraction &&
      nextQueryId &&
      nextQueryId !== currentQueryIdRef.current
    ) {
      currentQueryIdRef.current = nextQueryId;
      navigate(`/datasources/${datasourceId}/queries/${nextQueryId}`);
    }
  }, [nextQueryId, datasourceId, lastUpdateMethod]);
};
